var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-time-picker',{staticClass:"pt-2",attrs:{"date":_vm.fetchDate,"pickerOptions":_vm.pickerOptions,"rangeSeparator":_vm.rangeSeparator,"clearable":false},on:{"on-change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }